import script from "./filesUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./filesUpload.vue?vue&type=script&setup=true&lang=js"

import "./filesUpload.vue?vue&type=style&index=0&id=9798c98a&lang=scss"

const __exports__ = script;

export default __exports__